import React, { useCallback, useState } from "react";
import axios from "axios";
import debounce from "lodash.debounce";
import Dialog from "rc-dialog";
import Select from "react-select-new/async";

export const CopyStudentToCourseModal = ({ items, contextData, addGlobalMessage, close, onSuccess }) => {
    const [course, setCourse] = useState(false);
    const [error, setError] = useState("");

    const limit = 2;

    const copyStudents = useCallback(async (students, courseDetail) => {
        const data = students.map((user) => ({ uuid: user }));

        axios.post(`/v1/courses/${course.uuid}/students/`, data).then((results) => {
            const done = () => {
                addGlobalMessage({
                    title: "De geselecteerde cursisten zijn succesvol gekopieerd naar de cursus.",
                    link: `/courses/edit/${course.uuid}/students`
                });

                if (typeof onSuccess === "function") {
                    onSuccess();
                }
                close();
            };

            const studentOptions = {
                employer_specific: false,
                insured: false
            };

            if (Object.values(studentOptions).some(Boolean)) {
                // Update the student options
                axios
                    .patch(`/v1/courses/${courseDetail.uuid}/`, {
                        student_options: students.map((user) => ({ user, ...studentOptions }))
                    })
                    .then(done)
                    .catch((error) => {
                        console.error(error, error.response.data);
                        setError("Er is een fout opgetreden bij het instellen van de optie bedrijfsspecifiek.");
                    });
            } else {
                done();
            }
        }).catch((error) => {
            // console.error(error, error.response.data);
            if (Array.isArray(error.response.data)) {
                // usually just 1 error, as an object with the field name as keys
                setError(
                    error.response.data.map(
                        (e) => Object.values(e).join(" ")
                    ).join(" ")
                );
            } else {
                console.error("unknown error response format", error.response.data);
                setError("Er is een fout opgetreden bij het kopiëren van de cursisten.");
            }
        });
    });

    const _getOptions = (input, callback) => {
        if (limit && (input === "" || input.length < limit)) {
            callback([]);
        } else {
            axios
                .get(
                    `/v1/courses/?is_editable=true&limit=25&fields=uuid,id,your_reference,start_datetime,employer_specific_available,insurance_available&search_type=courses&search=${input}`
                )
                .then((res) => {
                    const result = res?.data?.results || res?.data || [];
                    callback(result);
                });
        }
    };

    const getOptions = debounce(_getOptions, 500);

    const footerButtons = [
        <button
            type="button"
            className="btn btn-light"
            key="no"
            onClick={() => {
                close();
            }}
        >
            Nee, geen cursisten kopieëren
        </button>
    ];

    if (course) {
        footerButtons.push([
            <button
                type="button"
                className="btn btn-primary"
                key="yes"
                onClick={() => {
                    copyStudents(items, contextData?.courseDetail);
                }}
            >
                Kopieer cursisten naar de gekozen cursus
            </button>
        ]);
    }

    return (
        <>
            <Dialog title={"Kopieer cursisten naar andere cursus"} onClose={() => close()} visible={true} animation="fade" footer={footerButtons}>
                <p className={"paragraph"}>
                    Ik wil {items?.length || ""} cursist{items?.length !== 1 ? "en" : ""} kopiëren naar deze cursus:
                </p>
                <Select
                    cacheOptions
                    defaultOptions
                    name={"course-select"}
                    valueKey={"uuid"}
                    labelKey={"your_reference"}
                    searchPromptText={"Typ om te zoeken..."}
                    placeholder={"Typ om te zoeken..."}
                    onChange={(opt) => setCourse(opt)}
                    loadingMessage={() => "Laden..."}
                    noOptionsMessage={() => "Niets gevonden met deze zoekterm..."}
                    getOptionLabel={(o) => o.id + " - " + o.your_reference}
                    getOptionValue={(o) => o.uuid}
                    value={course}
                    loadOptions={(input, callback) => getOptions(input, callback)}
                    isClearable={true}
                />
                {error || ""}
            </Dialog>
        </>
    );
};
